import { takeLatest, put, call, select, debounce } from 'redux-saga/effects';
import { getMentionsFailure, getMentionsSuccess, GET_MENTIONS_REQUEST } from '../actions/mentions';
import {getMentionsService} from '../services/mentions';
import {showGlobalError} from '../../app/actions/app';
import {accessTokenSelector} from '../../auth/selectors/token';

export const getMentionsWorker = function* (){
    try {

        const token = yield select(accessTokenSelector);

        const { data: { mentions, total } } = yield call(getMentionsService, token);

        yield put(getMentionsSuccess(mentions,total));
        
    } catch (err) {
        yield put(getMentionsFailure(err));
        yield put(showGlobalError(true, err.response?.data?.error?.code, err.response?.data?.error?.errorKey));
    }
}


export default [
    takeLatest(GET_MENTIONS_REQUEST, getMentionsWorker)
]